import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphTwins } from "../../../components/paragraph-twins";
import { SolutionHeader } from "../../../components/solution-header";
import { ImageTextTriplets } from "../../../components/image-text-triplets";
import { Insight } from "../../../components/insight";
import { Video } from "../../../components/video";

export interface IImpactProps {
	sectionId: string;
	index: number;
}

export function Impact(props: IImpactProps) {
	const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
	return (
		<Section sectionId={props.sectionId} isLast={false}>
			<SectionHeader title={`${formattedIndex} Impact`} />

			<SolutionHeader
				title="Value for Platforms"
				description="Our solution doesn't just empower platform users to combat misinformation. Social platforms will also benefit in the following ways:"
			/>

			<ParagraphTwins
				p1={{
					title: "Higher Engagement",
					body: [
						"Increased user confidence in information on the platform can make users more active and engaged",
					],
				}}
				p2={{
					title: "Improve Reputation",
					body: [
						"Better monitoring of the information circulating on platforms leads to improvements in public image and user trust",
					],
				}}
			/>

			<Video
				videoSrc={"https://www.youtube.com/embed/ZelG1B_NkHU"}
			/>

			<SolutionHeader
				title="Societal Impact"
				description="Ultimately, we believe that this solution can bring positive change to not only individual users and platforms, but society as a whole."
			/>

			<ParagraphTwins
				p1={{
					title: "Increasing Credibility",
					body: [
						"Giving people the tools to discern fact from fiction will lead to improvements in people's ability and willingness to evaluate credibility, even outside of the platform. ",
					],
				}}
				p2={{
					title: "Reducing harm",
					body: [
						"Arming everyday people with the ability to discern the truth will lead to fewer people spreading and believing in misinformation, reducing its capacity for causing harm.",
					],
				}}
			/>

			<Insight
				insight={{
					body:
						"One week after testing, we saw a 27% increase in participants who took action against misinformation ",
				}}
				index={0}
			/>

			<SolutionHeader
				title="Measuring Success"
				description="If platforms were to roll out this solution, there are a few ways we'd recommend measuring impact:"
			/>

			<ImageTextTriplets
				children={[
					{
						title: "Misinformation Levels",
						body:
							"The amount of content containing misinformation on the platform should decrease.",
					},
					{
						title: "User Engagement",
						body:
							"The amount of user engagement with misinformation, such as likes, comments and shares, should decrease.",
					},
					{
						title: "User Satisfaction",
						body:
							"User satisfaction in the platform's response to misinformation should increase.",
					},
				]}
			/>
			<Insight
				insight={{
					body:
						"One week after testing, we saw a 12% increase in participants who reported feeling skeptical of information while using social media",
				}}
				index={1}
			/>
		</Section>
	);
}
